import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Transition } from 'react-transition-group'
import cn from 'classnames'
import ProjectSlide from './ProjectSlide/ProjectSlide'
import ProjectsPrint from './ProjectsPrint'
import GallerySlider from './GallerySlider/GallerySlider'
import PROJECT_LIST from '../../content/projectList'
import { MOBILE_VIEW, TABLET_VIEW } from '../../constants/dimentions'
import flatten from '../../utils/flatten'
import './style.css'

const closestYear = Number(Object.keys(PROJECT_LIST).reverse()[0])
const projectList = flatten(Object.values(PROJECT_LIST).reverse())

WrapComponentWithSlideNavigation.propTypes = {
  children: PropTypes.node,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  isNavigation: PropTypes.bool,
  className: PropTypes.string
}

function WrapComponentWithSlideNavigation ({
  children, onPrev, onNext, isNavigation, className
}) {
  return (
    <div className={className}>
      {isNavigation && (<button type='button' className='projects_project-card__arrow projects_project-card__arrow-up' onClick={onPrev} />)}
      {children}
      {isNavigation && (<button type='button' className='projects_project-card__arrow projects_project-card__arrow-down' onClick={onNext} />)}
    </div>
  )
}

class Projects extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string
    }),
    history: PropTypes.shape({
      push: PropTypes.func
    }),
    match: PropTypes.shape({
      params: PropTypes.shape({
        slug: PropTypes.string
      })
    }),
    screenWidth: PropTypes.number
  }

  state = {
    currentYear: closestYear,
    activeProjectNum: 0,
    projectIndex: 0,
    runAnimation: false
  }

  componentDidMount () {
    this.init()
    window.onunload = function handleOnUnload () {
      window.scrollTo(0, 0)
    }
  }

  componentDidUpdate (prevProps) {
    const { location } = this.props
    if (prevProps.location.pathname !== location.pathname) {
      this.init()
    }
  }

  init = () => {
    const { match } = this.props
    const project = projectList.find(prj => prj.slug.toLowerCase() === match.params.slug.toLowerCase())
    const projectIndex = projectList.findIndex(prj => prj.slug.toLowerCase() === match.params.slug.toLowerCase())
    const projectYear = project && String(project.year).slice(-2)
    const projectNum = project && PROJECT_LIST[projectYear].findIndex(prj => prj.slug.toLowerCase() === match.params.slug.toLowerCase())

    project && this.setState({
      projectIndex,
      currentYear: projectYear,
      activeProjectNum: projectNum,
      runAnimation: true
    })
    this.clearAnimation()
  }

  clearAnimation = () => {
    setTimeout(() => { this.setState({ runAnimation: false }) }, 50)
  }

  onProjectChange = (index) => {
    const project = projectList[index]
    const projectYear = project && String(project.year).slice(-2)
    const projectNum = project && PROJECT_LIST[projectYear].findIndex(prj => prj.slug.toLowerCase() === project.slug.toLowerCase())

    this.setState({ projectIndex: index, currentYear: projectYear, activeProjectNum: projectNum },
      () => index >= 0 && this.changeLocationForProject(index)
    )
    this.clearAnimation()
  }

  onPrev = () => {
    const { projectIndex } = this.state
    const newIndex = projectIndex > 0 ? projectIndex - 1 : projectIndex
    this.setState({ projectIndex: newIndex, runAnimation: true })
    this.changeLocationForProject(newIndex)
    this.clearAnimation()
  }

  onNext = () => {
    const { projectIndex } = this.state
    const newIndex = projectIndex < projectList.length - 1 ? projectIndex + 1 : projectIndex
    this.setState({ projectIndex: newIndex, runAnimation: true })
    this.changeLocationForProject(newIndex)
    this.clearAnimation()
  }

  changeLocationForProject = (index) => {
    const { history } = this.props
    return history.push(`/portfolio/projects/${projectList[index].slug}`)
  }

  onQuickYearSwitch = (year) => {
    const newIndex = projectList.findIndex(prj => String(prj.year).slice(-2) === year)
    this.setState({
      projectIndex: newIndex,
      currentYear: year,
      activeProjectNum: 0,
      runAnimation: true
    },
    () => {
      this.changeLocationForProject(newIndex)
      this.projectSlider && this.projectSlider.slideTo(newIndex, 0)
      this.clearAnimation()
    })
  }

  render () {
    const {
      currentYear, activeProjectNum, projectIndex, runAnimation
    } = this.state
    const { screenWidth } = this.props

    const isDesktop = screenWidth > TABLET_VIEW
    const isMobile = screenWidth <= MOBILE_VIEW
    const PROJECT = projectList[projectIndex || 0]
    const duration = 1100
    const delay = 200
    const transitionFn = 'cubic-bezier(0.22, 0.61, 0.36, 1)'
    const defaultGalleryStyle = {
      transition: `all ${duration}ms ${delay}ms ${transitionFn}`,
      opacity: 0,
      height: '100%'
    }
    const defaultCardStyle = {
      transition: `all ${duration}ms ${transitionFn}`,
      opacity: 0,
      transform: `translateY(100px)`
    }
    const transitionGalleryStyles = {
      entering: {
        opacity: 0
      },
      entered: {
        opacity: 0
      },
      exiting: {
        opacity: 1
      },
      exited: {
        opacity: 1
      }
    }
    const transitionCardStyles = {
      entering: {
        opacity: 0,
        transform: `translateY(100px)`
      },
      entered: {
        opacity: 0,
        transform: `translateY(100px)`
      },
      exiting: {
        opacity: 1,
        transform: `translateY(0)`
      },
      exited: {
        opacity: 1,
        transform: `translateY(0)`
      }
    }

    return (
      <div>
        {
          PROJECT && (
            <Fragment>
              <div className='projects_projects-container'>
                <h1 className='title'>
                  {isMobile
                    ? <span><span className='title__route-name'>portfolio /</span> projects</span>
                    : (
                      <span
                        key={`title${[currentYear]}${[activeProjectNum]}}`}
                        className='projects__title'
                        style={{ color: PROJECT.titleColor }}
                      >
                        Projects
                      </span>
                    )}
                </h1>
                <div
                  className='projects_project-slider'
                  style={{ width: isMobile ? screenWidth : '100%' }}
                >
                  <div
                    className='project-slide'
                    data-history={PROJECT.slug}
                    key={PROJECT.slug}
                  >
                    <div
                      className='projects_project-gallery-slider'
                    >
                      <Transition in={runAnimation} timeout={0}>
                        {state => (
                          <div
                            style={{
                              ...defaultGalleryStyle,
                              ...transitionGalleryStyles[state]
                            }}
                          >
                            <GallerySlider
                              gallery={PROJECT.gallery}
                              dotColor={PROJECT.titleColor}
                            />
                          </div>
                        )}
                      </Transition>
                    </div>
                    <Transition in={runAnimation} timeout={0}>
                      {state => (
                        <WrapComponentWithSlideNavigation
                          isNavigation={isDesktop}
                          className='projects_project-card'
                          onPrev={this.onPrev}
                          onNext={this.onNext}
                        >
                          <ProjectSlide
                            key={`${PROJECT.name}${currentYear}`}
                            project={PROJECT}
                            style={{
                              ...defaultCardStyle,
                              ...transitionCardStyles[state]
                            }}
                            className='project-slide-wrapper'
                          />
                        </WrapComponentWithSlideNavigation>
                      )}
                    </Transition>
                  </div>
                </div>
                <div className='project-card-progress'>
                  <WrapComponentWithSlideNavigation
                    isNavigation={!isDesktop}
                    className='progress-card-progress__wrapper'
                    onPrev={this.onPrev}
                    onNext={this.onNext}
                  >
                    <ul className='switcher'>
                      {Object.keys(PROJECT_LIST).reverse().map(year => (
                        <li
                          className={`switcher__block ${Number(year) === Number(currentYear) ? 'switcher__open' : 'switcher__closed'}`}
                          key={year}
                        >
                          <button
                            type='button'
                            onClick={() => this.onQuickYearSwitch(year)}
                            className='switcher__block-year'
                          >
                            {year}
                          </button>
                          <ul className='switcher__block-lines'>
                            {[...Array(PROJECT_LIST[year].length)].map((item, i) => (
                              <li
                                className={
                                  cn('switcher__block-line',
                                    { 'switcher__block-line__active': i === activeProjectNum && Number(year) === Number(currentYear) })
                                }
                                key={i}
                              />
                            )
                            )}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </WrapComponentWithSlideNavigation>
                </div>
              </div>
              <div className='projects-print_projects-container'>
                <ProjectsPrint
                  project={PROJECT}
                />
              </div>
            </Fragment>
          )
        }
      </div>
    )
  }
}

export default withRouter(Projects)
